import BaseModel from './BaseModel';

export default {
  ...BaseModel,

  endpoint: '/bike_transport_plan_bike_type',
  getId: data => `${data.bike_transport_plan_id}:${data.bike_type_id}`,
};
